import img1 from "../../assets/Images/Event Booking/Event-Booking.png"
export default function Bookings() {
    return (
        <section id="bookings" className="space-y-16">

            {/* SECTION TITLE */}
            <div>
                <h2 className="text-xl font-semibold text-[#C9A24E] mb-3">
                    2.2 Bookings
                </h2>
                <p className="text-slate-600 max-w-3xl">
                    This section explains how to view, filter, and manage all event
                    bookings recorded in EventFlow. It serves as the central control
                    panel for booking operations, payments, and status management.
                </p> <br />
                <p className="text-slate-600">
                    The Bookings screen displays a complete list of all events booked in
                    the system. Staff can filter records, review financials, take actions,
                    and track booking status throughout the event lifecycle.
                </p>
            </div>

            {/* OVERVIEW */}
            {/* <section className="bg-white border-l border-[#C9A24E] p-4">
                <h3 className="text-lg font-semibold mb-2">
                    Overview
                </h3>
                
            </section> */}

            {/* TOP FILTER BAR */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Booking Filters & Controls
                    </h3>
                    <p className="text-slate-600 mb-3">
                        The top section of the bookings page contains powerful filters that
                        help staff quickly locate specific bookings.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Date range (From / To)</li>
                        <li>Date type (Event Date or Booking Date)</li>
                        <li>Slot (Morning / Evening / Both)</li>
                        <li>Status (Confirmed, Canceled, Cleared)</li>
                        <li>Hall portion selection</li>
                    </ul>
                </div>
            </section>

            {/* NEW BOOKING BUTTON */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    New Booking Action
                </h3>

                <p className="text-slate-600 mb-3">
                    The <strong>New Booking</strong> button is available in the top-right
                    corner of the bookings page.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Opens the Add Booking form</li>
                    <li>Used when a customer confirms an event</li>
                    <li>Automatically checks availability</li>
                </ul>
            </section>

            {/* BOOKINGS TABLE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Booking List Table
                </h3>

                <p className="text-slate-600 mb-4">
                    The booking table displays all bookings matching the selected filters.
                    Each row represents a single event booking.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Booking number & booking date</li>
                    <li>Customer name & event type</li>
                    <li>Event date, hall, slot & portion</li>
                    <li>Total amount, received & due balance</li>
                    <li>Current booking status</li>
                </ul>

                <div className="bg-slate-100 rounded-lg p-4 text-sm text-slate-500 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ACTIONS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Booking Actions
                </h3>

                <p className="text-slate-600 mb-3">
                    Each booking row includes an Actions menu allowing staff to manage the
                    booking throughout its lifecycle.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li><strong>Invoice</strong> – View booking invoice</li>
                    <li><strong>Edit</strong> – Modify booking details</li>
                    <li><strong>Receipt</strong> – Record a payment</li>
                    <li><strong>Receipt Print</strong> – Print payment receipt</li>
                    <li><strong>Mark as Confirmed</strong> – Confirm the booking</li>
                    <li><strong>Mark as Shifted</strong> – Move booking to another date</li>
                    <li><strong>Mark as Canceled</strong> – Cancel the booking</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Booking Management Is Important
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Proper booking management ensures accurate scheduling, financial
                    transparency, conflict prevention, and professional customer handling.
                    This screen acts as the operational backbone of EventFlow.
                </p>
            </section>

        </section>
    );
}
